<div class="bn-tab-header" [ngClass]="{'align-items-start': !isAcmic && showMortgagee && policy?.displayType?.label === 'Personal property'  && policy?.billingDetails?.[0]?.mortageeFlag === 'Y', 'bn-tab-header-overview': isBillingDetails, 'bn-tab-header-documents': isBillingDocuments}">
    <div class="bn-tab-header-left" [ngClass]="{'bn-tab-header-height': !isAcmic && showMortgagee && policy?.billingDetails?.[0]?.mortageeFlag === 'Y'}">
      <img 
        src="{{policy?.displayType?.icon}}" 
        class="margin-right mr8" 
        width="32" height="32" 
        alt="{{policy?.policyType?.toLowerCase()}} icon"
      />
      <div class="nowrap" [ngClass]="{'bn-tab-header-height': !isAcmic && showMortgagee && policy?.displayType?.label === 'Personal property' && policy?.billingDetails?.[0]?.mortageeFlag === 'Y'}">
        {{ policy?.displayType?.label | translate }} &ndash; {{ policy?.policynumber.policyNumber }} 
        <div *ngIf="!isAcmic && showMortgagee && policy?.displayType?.label === 'Personal property' && policy?.billingDetails?.[0]?.mortageeFlag === 'Y'" class="mortgagee-inline ml-desktop">
          {{'MORTGAGEE_TEXT' | translate}}
          <app-mortgagee-custom-tooltip></app-mortgagee-custom-tooltip>
        </div> 
      </div>
    </div>
    <div 
      *ngIf="!hideTerm"
      class="bn-date bn-tab-header-right"
      [ngClass]="{'bn-cancel-text': policy?.policyStatus === 'CANCELLED' || policy?.policyStatus === 'INACTIVE', 'bn-tab-header-date': !isAcmic}"
    >
        <ng-container *ngIf="policy?.policyStatus === 'CANCELLED'">{{'Cancelled '}}</ng-container>
        <ng-container *ngIf="policy?.policyStatus === 'INACTIVE'">{{'Inactive '}}</ng-container>
        {{ policy?.effDate | customDateFormat }} - {{ policy?.expDate | customDateFormat }}
    </div>
</div>
<div *ngIf="!isAcmic && showMortgagee && policy?.displayType?.label === 'Personal property'  && policy?.billingDetails?.[0]?.mortageeFlag === 'Y'" class="mortgagee-inline ml-mobile">
    {{'MORTGAGEE_TEXT' | translate}}
    <app-mortgagee-custom-tooltip></app-mortgagee-custom-tooltip>
  </div>
<hr class="thin-hr" [ngClass]="{'hr-rule-acmic':isAcmic, 'hr-rule-ma':!isAcmic, 'mb-4 mt-4': isBillingDetails}">
